import React from "react";
import { motion } from "framer-motion";
import { Handshake, Target, Rocket, TrendingUp } from "lucide-react";

const values = [
  {
    icon: Handshake,
    title: "Collaboration",
    desc: "Nous travaillons en étroite relation avec nos clients pour construire des solutions adaptées.",
    color: "#E52431",
  },
  {
    icon: Target,
    title: "Engagement",
    desc: "Nous nous impliquons pleinement dans chaque projet avec exigence et rigueur.",
    color: "#1F2C6E",
  },
  {
    icon: Rocket,
    title: "Innovation",
    desc: "Nous proposons des solutions modernes et performantes.",
    color: "#E52431",
  },
  {
    icon: TrendingUp,
    title: "Croissance",
    desc: "Notre objectif est de générer des résultats concrets et durables.",
    color: "#1F2C6E",
  },
];

export default function Values() {
  return (
    <section
      data-testid="values-section"
      className="relative py-24 md:py-32 section-light"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mb-16"
        >
          <span className="text-xs uppercase tracking-[0.25em] text-[#E52431]">
            — Notre approche
          </span>
          <h2 className="mt-4 font-outfit text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-[#0A0A0A]">
            Quatre valeurs,{" "}
            <span className="gradient-text font-medium">une exigence</span>
          </h2>
          <p className="mt-6 text-[#0A0A0A]/60 text-lg font-light">
            Les piliers qui guident chacun de nos projets.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {values.map((v, i) => {
            const Icon = v.icon;
            return (
              <motion.div
                key={v.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: i * 0.08 }}
                whileHover={{ y: -6 }}
                data-testid={`value-card-${i}`}
                className="light-card light-card-hover rounded-3xl p-8 transition-all duration-500"
              >
                <div
                  className="h-14 w-14 rounded-2xl grid place-items-center mb-6"
                  style={{
                    background: `linear-gradient(135deg, ${v.color}18, ${v.color}08)`,
                    border: `1px solid ${v.color}25`,
                  }}
                >
                  <Icon size={22} style={{ color: v.color }} strokeWidth={1.5} />
                </div>
                <h3 className="font-outfit text-xl md:text-2xl font-medium text-[#0A0A0A]">
                  {v.title}
                </h3>
                <p className="mt-3 text-[#0A0A0A]/60 leading-relaxed font-light text-sm md:text-base">
                  {v.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
